import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const PlusColorSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.7499 2.82104C6.60778 2.82104 3.24992 6.1789 3.24992 10.321C3.24992 14.4632 6.60778 17.821 10.7499 17.821C14.8921 17.821 18.2499 14.4632 18.2499 10.321C18.2499 6.1789 14.8921 2.82104 10.7499 2.82104ZM1.58325 10.321C1.58325 5.25843 5.68731 1.15437 10.7499 1.15437C15.8125 1.15437 19.9166 5.25843 19.9166 10.321C19.9166 15.3836 15.8125 19.4877 10.7499 19.4877C5.68731 19.4877 1.58325 15.3836 1.58325 10.321Z'
      fill='url(#paint0_linear_199_12287)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.7501 6.15437C11.2103 6.15437 11.5834 6.52747 11.5834 6.98771V13.6544C11.5834 14.1146 11.2103 14.4877 10.7501 14.4877C10.2898 14.4877 9.91675 14.1146 9.91675 13.6544V6.98771C9.91675 6.52747 10.2898 6.15437 10.7501 6.15437Z'
      fill='url(#paint1_linear_199_12287)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.58325 10.321C6.58325 9.86081 6.95635 9.48772 7.41659 9.48772H14.0833C14.5435 9.48772 14.9166 9.86081 14.9166 10.321C14.9166 10.7813 14.5435 11.1544 14.0833 11.1544H7.41659C6.95635 11.1544 6.58325 10.7813 6.58325 10.321Z'
      fill='url(#paint2_linear_199_12287)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_199_12287'
        x1='1.58325'
        y1='1.15437'
        x2='20.5883'
        y2='1.87936'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_199_12287'
        x1='9.91675'
        y1='6.15437'
        x2='11.6469'
        y2='6.16757'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_199_12287'
        x1='6.58325'
        y1='9.48772'
        x2='14.9308'
        y2='11.0799'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
    </defs>
  </svg>
);

export const PlusColorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PlusColorSvg} {...props} />
);
